// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Categories - Optimized with main categories and subcategories
export const CATEGORIES = [
  { 
    id: 'ciencia', 
    name: 'Ciencia', 
    icon: '🔬', 
    color: '#06b6d4',
    subcategories: ['Tecnología', 'Medicina', 'Física', 'Biología', 'Astronomía']
  },
  { 
    id: 'cultura', 
    name: 'Cultura', 
    icon: '🎭', 
    color: '#8b5cf6',
    subcategories: ['Arte', 'Literatura', 'Música', 'Cine', 'Teatro']
  },
  { 
    id: 'sociedad', 
    name: 'Sociedad', 
    icon: '👥', 
    color: '#3b82f6',
    subcategories: ['Política', 'Economía', 'Educación', 'Derechos', 'Comunidad']
  },
  { 
    id: 'medio-ambiente', 
    name: 'Medio Ambiente', 
    icon: '🌍', 
    color: '#10b981',
    subcategories: ['Cambio Climático', 'Energías Renovables', 'Conservación', 'Sostenibilidad']
  },
  { 
    id: 'entretenimiento', 
    name: 'Entretenimiento', 
    icon: '🎮', 
    color: '#ec4899',
    subcategories: ['Gaming', 'Deportes', 'Series', 'Memes', 'Viral']
  },
  { 
    id: 'lifestyle', 
    name: 'Lifestyle', 
    icon: '✨', 
    color: '#f59e0b',
    subcategories: ['Salud', 'Fitness', 'Viajes', 'Gastronomía', 'Moda']
  }
];

// Validation patterns
export const VALIDATION = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 8,
  USERNAME_MIN_LENGTH: 3,
  USERNAME_MAX_LENGTH: 30
};

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'graphyra_token',
  USER: 'graphyra_user',
  THEME: 'graphyra_theme'
};

// Reactions - Style similar to Facebook but for scientific content
export const REACTIONS = [
  { id: 'like', emoji: '👍', label: 'Me gusta', color: '#6366f1' },
  { id: 'love', emoji: '❤️', label: 'Me encanta', color: '#ef4444' },
  { id: 'smart', emoji: '🤓', label: 'Interesante', color: '#f59e0b' },
  { id: 'wow', emoji: '😮', label: 'Increíble', color: '#10b981' },
  { id: 'think', emoji: '🤔', label: 'Me hace pensar', color: '#8b5cf6' }
];

export const SCIENTIFIC_REACTIONS = REACTIONS;
